import React from "react";
import styles from "./TermPopUp.module.css";

interface OptionalProps {
    optional: string;
    onClose: () => void;
}

//개인정보 처리 규정 팝업
const OptionalPopUp: React.FC<OptionalProps> = ({optional, onClose}) => {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.popup} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        개인정보 수집·이용 동의
                    </div>
                    <button onClick={onClose} className={styles.closeButton}>
                        ×
                    </button>
                </div>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{__html: optional}}
                />
            </div>
        </div>
    )
}

export default OptionalPopUp;